import React, { Component, createRef } from 'react';

// CSS
import '../Subscriptions/Subscription.scss';

// Helper
import { checkCookie } from '../../Helper/Cookies';
import { apiFetch } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

// Properties
const properties = require('../../properties.json');

class ContactInfo extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = {
        email: '',
        mobile: '',
        location: '',
        facebookUrl: '',
        instagramUrl: '',
        linkedinUrl: '',
        behanceUrl: '',
        saving: false,
        loading: true,
    }

    componentDidMount() {
        document.title = properties.site_name + " | معلومات التواصل";
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
            return;
        }
        apiFetch("/teachers/me")
            .then(me => {
                this.setState({
                    email: me.email || '',
                    mobile: me.mobile || '',
                    location: me.location || '',
                    facebookUrl: me.facebookUrl || '',
                    instagramUrl: me.instagramUrl || '',
                    linkedinUrl: me.linkedinUrl || '',
                    behanceUrl: me.behanceUrl || '',
                    loading: false,
                });
            })
            .catch(error => {
                this.setState({ loading: false });
                console.error('Error:', error);
            });
    }

    save = () => {
        const { email, mobile, location, facebookUrl, instagramUrl, linkedinUrl, behanceUrl } = this.state;
        this.setState({ saving: true });
        apiFetch("/teachers/me/contact-info", { method: "PUT", body: { email, mobile, location, facebookUrl, instagramUrl, linkedinUrl, behanceUrl } })
            .then(() => {
                this.setState({ saving: false });
                this.toast.current.show({ severity: 'success', summary: 'تم بنجاح', detail: 'تم حفظ معلومات التواصل' });
            })
            .catch(error => {
                this.setState({ saving: false });
                this.toast.current.show({ severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال' });
            });
    }

    render() {
        const { email, mobile, location, facebookUrl, instagramUrl, linkedinUrl, behanceUrl, saving, loading } = this.state;

        return (
            <>
                <Header pageName="معلومات التواصل" />
                <Toast ref={this.toast}></Toast>
                <div className="content">
                    <div className="container">
                        <div className="card">
                            <Card title="بيانات التواصل ووسائل التواصل الاجتماعي">
                                {!loading &&
                                    <div className="p-col-12 p-md-8 p-m-3">
                                        <p>
                                            دي البيانات اللي هتظهر في صفحة "تواصل معنا" على موقعك الخارجي.
                                            ممكن تكون مختلفة عن بريد وموبايل الدخول بتاعك.
                                        </p>

                                        <div className="p-col-12 p-md-12" style={{ marginTop: 16 }}>
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <InputText
                                                        value={email}
                                                        placeholder="example@email.com"
                                                        onChange={(e) => this.setState({ email: e.target.value })}
                                                    />
                                                    <label>البريد الإلكتروني للتواصل</label>
                                                </span>
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-md-12">
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <InputText
                                                        value={mobile}
                                                        placeholder="01xxxxxxxxx"
                                                        onChange={(e) => this.setState({ mobile: e.target.value })}
                                                    />
                                                    <label>رقم الموبايل للتواصل</label>
                                                </span>
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-md-12" style={{ marginTop: 16 }}>
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <InputText
                                                        value={location}
                                                        placeholder="مثال: المنصورة، مصر"
                                                        onChange={(e) => this.setState({ location: e.target.value })}
                                                    />
                                                    <label>الموقع (المدينة/الدولة)</label>
                                                </span>
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-md-12">
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <InputText
                                                        value={facebookUrl}
                                                        placeholder="https://facebook.com/..."
                                                        onChange={(e) => this.setState({ facebookUrl: e.target.value })}
                                                    />
                                                    <label>رابط فيسبوك</label>
                                                </span>
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-md-12">
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <InputText
                                                        value={instagramUrl}
                                                        placeholder="https://instagram.com/..."
                                                        onChange={(e) => this.setState({ instagramUrl: e.target.value })}
                                                    />
                                                    <label>رابط إنستجرام</label>
                                                </span>
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-md-12">
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <InputText
                                                        value={linkedinUrl}
                                                        placeholder="https://linkedin.com/in/..."
                                                        onChange={(e) => this.setState({ linkedinUrl: e.target.value })}
                                                    />
                                                    <label>رابط لينكد إن</label>
                                                </span>
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-md-12">
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <InputText
                                                        value={behanceUrl}
                                                        placeholder="https://behance.net/..."
                                                        onChange={(e) => this.setState({ behanceUrl: e.target.value })}
                                                    />
                                                    <label>رابط بيهانس</label>
                                                </span>
                                            </div>
                                        </div>

                                        <p style={{ fontSize: 13, color: '#888' }}>
                                            سيب أي رابط فاضي لو مش عايز الأيقونة بتاعته تظهر في صفحة التواصل.
                                        </p>

                                        <div className="p-col-12 p-md-12">
                                            <Button
                                                className={`add-button ${saving ? "loading" : ""}`}
                                                label={saving ? "جاري الحفظ..." : "حفظ"}
                                                disabled={saving}
                                                onClick={this.save}
                                            />
                                        </div>
                                    </div>
                                }
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ContactInfo;
